import { signOut, type Identity } from "@otto/plattform";
import { useSession } from "@otto/plattform";
import styles from "../../../shared/components/shell.module.css";

/**
 * Angemeldet, aber ohne Schulprofil. Zwei Fälle, beide brauchen einen anderen
 * Satz – ein leeres Dashboard oder ein ewiger Ladebalken wäre hier das
 * Schlimmste, weil die Person nicht weiß, ob sie warten oder handeln soll.
 */
export function NoAccess({ identity }: { identity: Identity }) {
  const { client } = useSession();

  return (
    <div className={styles.centered}>
      <div className={styles.signInCard}>
        {identity.isEditorial ? (
          <>
            <h1 className={styles.title}>Plattformzugang</h1>
            <p className={styles.subtitle}>
              Dieses Konto arbeitet in der Admin-App. Es hat bewusst keinen Zugriff auf
              Klassen und Ergebnisse – die gibt es nur hier in der Verwaltung.
            </p>
          </>
        ) : (
          <>
            <h1 className={styles.title}>Noch keiner Schule zugeordnet</h1>
            <p className={styles.subtitle}>
              Ihr Konto <strong>{identity.user.email}</strong> ist angemeldet, gehört aber
              noch zu keiner Schule. Ihre Schulleitung kann Sie im Bereich „Schule“
              hinzufügen.
            </p>
          </>
        )}
        <button
          type="button"
          className={styles.buttonQuiet}
          onClick={() => void signOut(client)}
        >
          Abmelden
        </button>
      </div>
    </div>
  );
}
